export default "__VITE_ASSET__B7wEuWh2__"